export const ViewMode = {
  SELECT: "SELECT",
  GRAB: "GRAB",
  DRAW: "DRAW",
};
